module.exports = __webpack_public_path__ + "static/media/link.c875c697.svg";